import React from "react";
import styled from "@emotion/styled";
import {BurgerButton, DesktopMenu, MobileMenu, StatsHeader} from "components";
import {useSelector} from "react-redux";
import {getIsMenuOpen} from "modules/selectors/common";
import {getClassAccordingBoolean} from "modules/utils/helpers";

const HeaderElement = styled.header`
	width: 100%;
	height: 66px;
	background: ${({theme}) => theme.header.background};
	color: ${({theme}) => theme.header.color};
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 20px;
	transition: 0.25s;

	&.open {
		background: ${({theme}) => theme.header.menu.background};
	}
`;

export const Header: React.FC = () => {
	const isOpen = useSelector(getIsMenuOpen);
	const className = getClassAccordingBoolean("open", isOpen);

	return (
		<React.Fragment>
			<HeaderElement className={className}>
				<BurgerButton />
				<DesktopMenu />
				<MobileMenu />
			</HeaderElement>

			<StatsHeader />
		</React.Fragment>
	);
};
